import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Main from 'layouts/Main/Main';
import FourDotsLoader from 'ui/FourDotsLoader/FourDotsLoader';

type Props = {
  to: string;
};

const RouteRedirect = ({ to }: Props): JSX.Element => {
  const { replace } = useRouter();

  useEffect(() => {
    replace(to);
  }, [replace, to]);

  return (
    <Main>
      <FourDotsLoader />
    </Main>
  );
};

export default RouteRedirect;
